import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-loader-placeholder',
  templateUrl: './loader-placeholder.component.html',
  styleUrls: ['./loader-placeholder.component.scss'],
})
export class LoaderPlaceholderComponent {
  @Input() cardHeader: string;
}
